export const ERROR = 'error';
export const ERROR_REASON = 'error_reason';
export const ERROR_TYPE = 'error_type';
export const MESSAGE = 'message';
export const TRACKING_ID = 'tracking_id';
export const CREDENTIALS = 'credentials';
export const PROVIDER_NAME = 'provider_name';
export const PAYMENT_REQUEST_ID = 'payment_request_id';
export const CREDENTIALS_ID_TINK_LINK = 'credentialsId';
export const STATE_TINK_LINK = 'state';
